import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {
  displayName: string
  className?: string
}

export const CompassRoleTxt: FC<Props> = ({ displayName, className }) => {
  return (
    <div className={className}>
      <Txt sizeType="s">{displayName}</Txt>
    </div>
  )
}
